// assets
import { IconHome, IconSettings, IconBell, IconCashBanknote, IconFileInvoice } from '@tabler/icons';

// constant
const icons = {
  IconHome,
  IconSettings,
  IconBell,
  IconCashBanknote,
  IconFileInvoice
};

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [
    {
      id: 'sample-docs-roadmap',
      type: 'group',
      children: [
        {
          id: 'home',
          title: 'Dashboard',
          type: 'item',
          url: '/dashboard',
          icon: icons.IconHome,
          breadcrumbs: false
        },
        {
          id: 'credit-apps',
          title: 'Credit Applications',
          type: 'item',
          url: '/credit-apps',
          icon: icons.IconFileInvoice,
          breadcrumbs: false
        },
        {
          id: 'monitor',
          title: 'Monitoring',
          type: 'item',
          url: '/monitoring',
          icon: icons.IconBell,
          breadcrumbs: false
        },
        {
          id: 'collections',
          title: 'Collections',
          type: 'item',
          url: '/collections',
          icon: icons.IconCashBanknote,
          breadcrumbs: false
        },
        {
          id: 'settings',
          title: 'Settings',
          type: 'item',
          url: '/settings',
          icon: icons.IconSettings,
          breadcrumbs: false
        },
      ]
    }
  ]
};

export default menuItems;
